/**
 * Landing CV API Service
 * Handles CV/application submission for career applications
 */

import { api } from "../core/api.client";
import { ApiClientResponse } from "../core/api.types";
import { LandingCv } from "../../types/landingCv";

export interface CreateLandingCvData {
  name: string;
  email: string;
  phone: string;
  file: string; // Media ID instead of File
  landingCareer: string;
}

export class LandingCvApi {
  private readonly endpoint = "landing-cv";

  /**
   * Submit a new CV application
   */
  async create(
    data: CreateLandingCvData
  ): Promise<ApiClientResponse<LandingCv>> {
    return api.post<LandingCv>(this.endpoint, {
      name: data.name,
      email: data.email,
      phone: data.phone,
      file: data.file, // Media ID
      landingCareer: data.landingCareer,
    });
  }

  /**
   * Get all CV applications (admin only)
   */
  async getAll(): Promise<ApiClientResponse<LandingCv[]>> {
    return api.get<LandingCv[]>(this.endpoint);
  }

  /**
   * Get CV application by ID
   */
  async getById(id: string): Promise<ApiClientResponse<LandingCv>> {
    return api.get<LandingCv>(`${this.endpoint}/${id}`);
  }

  /**
   * Delete CV application
   */
  async delete(id: string): Promise<ApiClientResponse<void>> {
    return api.delete(`${this.endpoint}/${id}`);
  }
}

// Export singleton instance
export const landingCvApi = new LandingCvApi();

// Export convenience methods
export const landingCv = {
  submit: (data: CreateLandingCvData) => landingCvApi.create(data),
  getAll: () => landingCvApi.getAll(),
  getById: (id: string) => landingCvApi.getById(id),
  delete: (id: string) => landingCvApi.delete(id),
};
